import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { withClient } from '@components';
import { PLATFORMS, IMG_CDN_URL } from '@constants';
import { UkAwards, ITAwards } from './constants';

import styles from './styles/index.module.scss';

const Awards = memo(({ platform }) => (
  <>
    {platform === PLATFORMS.GREAT_BRITAIN
      ? UkAwards.map(({ alt, src }) => (
          <div key={alt} className={styles.block}>
            <img
              alt={alt}
              className={styles.award}
              src={`${IMG_CDN_URL}/${src}`}
            />
          </div>
        ))
      : null}
    {platform === PLATFORMS.ITALY ? (
      <div className={styles.awardContainer}>
        {ITAwards.map(({ alt, src, dataQa }) => (
          <img
            key={alt}
            alt={alt}
            src={`${IMG_CDN_URL}/${src}`}
            className={styles.award}
            data-qa={dataQa}
          />
        ))}
      </div>
    ) : null}
  </>
));

Awards.propTypes = {
  platform: PropTypes.string.isRequired,
};

Awards.displayName = 'Awards';

export default withClient(Awards);
